import React, { useEffect, useRef } from 'react';
import ModelViewer from '@metamask/logo';

const MetamaskLogo = ({ width = 24, height = 24 }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    // Initialize the Metamask ModelViewer with desired options.
    const viewer = ModelViewer({
      pxNotRatio: true,
      width,
      height,
      followMouse: false,
      slowDrift: false,
    });
    if (containerRef.current) {
      containerRef.current.innerHTML = ''; // Clear container
      containerRef.current.appendChild(viewer.container);
      viewer.setFollowMouse(true);
    }
    // Cleanup on unmount
    return () => {
      viewer.stopAnimation();
    };
  }, [width, height]);

  return <div ref={containerRef} />;
};

export default MetamaskLogo;
